import config from 'config'
import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import PageHeader from '../PageHeader'
import Form from './Form'

const Notice = styled('p')`
  margin-top: ${props => props.theme.spacing['12']} !important;
`

const SignupPage = () => {
  return (
    <Fragment>
      <PageHeader
        primary={
          <Fragment>
            Try Groove free
            <br /> for {config.trialDays} days
          </Fragment>
        }
        secondary={
          <Fragment>
            Unlimited {app.t('agents')} and features.
            <br />
            No credit card required.
          </Fragment>
        }
      />
      <Form />
      <Notice>
        By continuing, you agree to Groove&apos;s{' '}
        <a
          href="https://www.groovehq.com/our/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href="https://www.groovehq.com/our/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        .
      </Notice>
    </Fragment>
  )
}

export default SignupPage
